import { fanficsCatalogSortMapping } from '@/lib/fanfics-catalog-api';
import type { AuthorWorksSortBy, GetAuthorWorksParams } from '../types/author-works.types';

export const AUTHOR_WORKS_PAGE_LIMIT = 12;

/**
 * Builds query for GET /api/fanfics-custom/v2 on the author profile.
 * `type` is intentionally omitted: without it the endpoint returns both
 * fanfics and originals, and `totalDocs` is the published works count.
 */
export function buildAuthorWorksQuery({
  userId,
  page = 1,
  limit = AUTHOR_WORKS_PAGE_LIMIT,
  sortBy = 'newest',
}: Pick<GetAuthorWorksParams, 'userId' | 'page' | 'limit' | 'sortBy'>): string {
  const queryParams = new URLSearchParams();
  queryParams.set('page', String(page));
  queryParams.set('limit', String(limit));
  queryParams.set('authorId', String(userId));
  queryParams.set('sort', fanficsCatalogSortMapping[sortBy as AuthorWorksSortBy]);
  return queryParams.toString();
}
